import React from 'react';
import ReactPlayer from 'react-player';
import './player.css';

export const VimeoPlayer = ({ url }) => {
  return (
    <div className='player-wrapper'>
      <ReactPlayer
        url={url}
        className='react-player'
        playing={false}
        controls={true}
        width="100%"
        height="100%"
        config={{
          youtube: {
            playerVars: {
              controls: 1,
              rel: 0,
            },
          },
          vimeo: {
            playerOptions: {
              controls: true
            }
          }
        }}
      />
    </div>
  );
};


